'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData$002dCreate$002dRequest$0024$002dPurchase$002dOrder from "./app.data.-App-Document-Data-Create-Request$-Purchase-Order.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder$() {
}
export { $c_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder$ as $c_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder$ };
$p = $c_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder$;
/** @constructor */
function $h_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder$() {
}
export { $h_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder$ as $h_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder$ };
$h_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder$.prototype = $p;
$p.n = (function() {
  return "PurchaseOrder";
});
$p.bKf = (function(x$0) {
  return new $j_app$002edata$002e$002dApp$002dDocument$002dData$002dCreate$002dRequest$0024$002dPurchase$002dOrder.$c_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder(x$0.e(0));
});
$p.U = (function(p) {
  return this.bKf(p);
});
var $d_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder$, "app.data.AppDocumentDataCreateRequest$PurchaseOrder$", ({
  Aq: 1,
  d: 1,
  e: 1
}));
export { $d_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder$ as $d_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder$ };
var $n_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder$;
function $m_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder$() {
  if ((!$n_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder$)) {
    $n_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder$ = new $c_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder$();
  }
  return $n_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder$;
}
export { $m_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder$ as $m_Lapp_data_AppDocumentDataCreateRequest$PurchaseOrder$ };
//# sourceMappingURL=app.data.-App-Document-Data-Create-Request$-Purchase-Order$.js.map
